import { Component } from 'react'
import { captureException } from '@/services/Sentry/Sentry'
import ErrorPage from './FC/ErrorPage/ErrorPage'

class ErrorBoundary extends Component<any, {hasError: boolean}> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  // React swallows errors a boundary catches, so they never reach the global
  // handler Sentry installs — report them here or lose every render failure.
  componentDidCatch(error: any, errorInfo: any) {
    console.error(error, errorInfo) // eslint-disable-line no-console
    captureException(error)
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />
    }
    return this.props.children
  }
}

export default ErrorBoundary
